import "../blocks/ConcertCard.css";

function ConcertCard({ concert }) {
  const { city, club, address, date, time, ticketLink } = concert;

  const handleBuyTicket = () => {
    window.open(ticketLink, "_blank");
  };

  return (
    <div className="concert-card">
      <div className="concert-card__container">
        <h4 className="concert-card__title">концерт</h4>
        <span className="concert-card__title-city">{city}</span>
      </div>
      <div className="concert-card__container">
        <p className="concert-card__club">{club}</p>
        <p className="concert-card__address">{address}</p>
      </div>
      <div className="concert-card__container">
        <p className="concert-card__date">{date}</p>
        <p className="concert-card__time">{time}</p>
      </div>
      <button onClick={handleBuyTicket} className="concert-card__button">
        купить
      </button>
    </div>
  );
}

export default ConcertCard;
